<template>
    <div id="ActivityMobileFilter">
        <ul class="base f12-mb">
            <li @click="changeExpand('search')">
                搜尋 <i class="icon-search"></i>
            </li>
            <li @click="changeExpand('location')">
                行政區<i class="toggle"></i>
            </li>
            <li @click="changeExpand('peopleCount')">
                活動人數<i class="toggle"></i>
            </li>
            <li @click="changeExpand('date')">
                活動日期<i class="toggle"></i>
            </li>
            <li @click="changeExpand('orderType')">
                排序<i class="toggle"></i>
            </li>
        </ul>
        <div class="overlay" :class="{ activated: expanded !== null }">
            <div class="mask" @click="changeExpand(null)"></div>
            <ul class="base f12-mb">
                <li @click="changeExpand('search')">
                    搜尋 <i class="icon-search"></i>
                </li>
                <li @click="changeExpand('location')">
                    行政區<i class="toggle"></i>
                </li>
                <li @click="changeExpand('peopleCount')">
                    活動人數<i class="toggle"></i>
                </li>
                <li @click="changeExpand('date')">
                    活動日期<i class="toggle"></i>
                </li>
                <li @click="changeExpand('orderType')">
                    排序<i class="toggle"></i>
                </li>
            </ul>
            <main class="f12-mb">
                <div v-show="expanded === 'search'" class="expanded-search">
                    <ElFormItem label="搜尋">
                        <ElInput
                            v-model.lazy="queryItems.keyword"
                            @change="updateRoute('keyword', queryItems.keyword)"
                            placeholder="請輸入欲搜索關鍵字"
                            title="搜尋"
                        >
                            <template #suffix>
                                <i
                                    class="icon-search"
                                    @click="changeExpand(null)"
                                ></i>
                            </template>
                        </ElInput>
                    </ElFormItem>
                </div>
                <div v-show="expanded === 'location'" class="expanded-location">
                    <ElFormItem area-label="行政區">
                        <div
                            class="activity-filter-location-group"
                            v-for="(item, index) of locationOptions"
                            :key="'location' + index"
                        >
                            <el-checkbox
                                :area-label="item.title"
                                v-model="checkBox.checkAll[index]"
                                :indeterminate="checkBox.isIndeterminate[index]"
                                @change="
                                    checkBox.handleCheckAllChange(index) +
                                        updateRoute(
                                            item.model,
                                            queryItems[item.model]
                                        )
                                "
                                >{{ item.title }}</el-checkbox
                            >
                            <el-checkbox-group
                                v-model="queryItems[item.model]"
                                @change="
                                    checkBox.handleCheckChange(index) +
                                        updateRoute(
                                            item.model,
                                            queryItems[item.model]
                                        )
                                "
                            >
                                <el-checkbox
                                    :area-label="city"
                                    v-for="city in item.options"
                                    :key="city"
                                    :label="city"
                                    >{{ city }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </div>
                    </ElFormItem>
                </div>
                <div
                    v-show="expanded === 'peopleCount'"
                    class="expanded-people-count"
                >
                    <ElSlider
                        v-model="sliderValue"
                        :max="200"
                        range
                        :step="10"
                        :marks="sliderMarks"
                    ></ElSlider>
                </div>
                <div v-show="expanded === 'date'" class="expanded-date">
                    <ElForm
                        ref="dateFormRef"
                        :model="dateFormData"
                        :rules="dateFormRule"
                    >
                        <ElFormItem label="起始日期" prop="startDate">
                            <ElDatePicker
                                v-model="dateFormData.startDate"
                                type="date"
                                placeholder="選擇起始日期"
                            ></ElDatePicker>
                        </ElFormItem>
                        <ElFormItem label="結束日期" prop="endDate">
                            <ElDatePicker
                                v-model="dateFormData.endDate"
                                placeholder="選擇結束日期"
                            ></ElDatePicker>
                        </ElFormItem>
                        <ElFormItem>
                            <div
                                class="filter-button"
                                role="button"
                                tabindex="0"
                                @click="submitForm"
                                @keypress.enter="submitForm"
                            >
                                篩選
                            </div>
                        </ElFormItem>
                    </ElForm>
                </div>
                <div
                    v-show="expanded === 'orderType'"
                    class="expanded-order-type"
                >
                    <ul class="f14-mb">
                        <li
                            @click="
                                updateRoute('orderType', 'desc') +
                                    changeExpand(null)
                            "
                        >
                            新到舊
                        </li>
                        <li
                            @click="
                                updateRoute('orderType', 'asc') +
                                    changeExpand(null)
                            "
                        >
                            舊到新
                        </li>
                    </ul>
                </div>
            </main>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ActivityMobileFilter',
}
</script>
<script setup>
import { reactive, ref, watch } from 'vue'
import { onBeforeRouteUpdate } from 'vue-router'
import moment from 'moment'
import { locationOptions } from '@/data/getActivityFilterOptions'
import { CheckBox } from '@/utils/checkbox.js'
import { initQueryItems, updateRoute } from '@/utils/query.js'
import { getStartDateRule, getEndDateRule } from '@/utils/form.js'
import {
    ElForm,
    ElFormItem,
    ElDatePicker,
    ElInput,
    ElCheckbox,
    ElCheckboxGroup,
    ElSlider,
} from 'element-plus'

onBeforeRouteUpdate((to) => {
    initQueryItems(queryItems, to.query)
})

// 初始化 query 數據
const queryItems = reactive({
    keyword: '',
    locationN: [],
    locationM: [],
    locationS: [],
    locationE: [],
    locationO: [],
    minParticipateNum: 0,
    maxParticipateNum: 200,
    startDate: '',
    endDate: '',
    orderType: '',
})
initQueryItems(queryItems)

// 處理行政區 checkbox 連動效果
let checkBox = new CheckBox(queryItems)
checkBox.initCheck()

// 處理人數 slider
const sliderValue = ref([
    queryItems.minParticipateNum,
    queryItems.maxParticipateNum,
])
watch(sliderValue, async () => {
    await new Promise((res) => {
        setTimeout(() => res(), 500)
    })
    updateRoute(['minParticipateNum', 'maxParticipateNum'], sliderValue.value)
})
const sliderMarks = {
    0: '0',
    100: '100',
    200: '200',
}

// 處理日期校驗與送出
const dateFormRef = ref(null)
const dateFormData = reactive({
    startDate: queryItems.startDate || null,
    endDate: queryItems.endDate || null,
})
const dateFormRule = reactive({
    startDate: getStartDateRule(dateFormData),
    endDate: getEndDateRule(dateFormData),
})
const submitForm = () => {
    dateFormRef.value.validate((valid) => {
        if (valid) {
            if (dateFormData.startDate && dateFormData.endDate) {
                updateRoute(
                    ['startDate', 'endDate'],
                    [
                        moment(dateFormData.startDate).format('YYYY/MM/DD'),
                        moment(dateFormData.endDate).format('YYYY/MM/DD'),
                    ]
                )
            } else if (dateFormData.startDate) {
                updateRoute(
                    ['startDate', 'endDate'],
                    [moment(dateFormData.startDate).format('YYYY/MM/DD'), '']
                )
            } else if (dateFormData.endDate) {
                updateRoute(
                    ['startDate', 'endDate'],
                    ['', moment(dateFormData.endDate).format('YYYY/MM/DD')]
                )
            } else {
                updateRoute(['startDate', 'endDate'])
            }
        } else {
            return false
        }
    })
}

// 處理頁面刷新
const expanded = ref(null)
function changeExpand(page) {
    if (expanded.value === page) {
        expanded.value = null
    } else expanded.value = page
}
watch(expanded, (newVal) => {
    if (newVal !== null) {
        document.body.style.height = '100vh'
        document.body.style.overflow = 'hidden'
    } else {
        document.body.style.height = 'auto'
        document.body.style.overflow = 'scroll'
    }
})
</script>
<style lang="scss" scoped>
#ActivityMobileFilter {
    position: relative;
    z-index: 1000;
    width: 100vw;
}
.base {
    display: flex;
    justify-content: space-around;
    padding: 0 0.5em 0.5em;
    color: $gray6;
    i.toggle {
        display: inline-block;
        margin-left: 5px;
        width: 0;
        height: 0;
        border: 3px solid transparent;
        border-top-color: $gray6;
    }
}
.overlay {
    display: none;
}
.overlay.activated {
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 100vw;
    height: 100vh;

    .mask {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 99%;
        width: 100%;
        background-color: rgba($black, 0.5);
    }
    .base {
        position: relative;
        background-color: $white;
        border-bottom: 1px solid $grayD;
    }
    main {
        position: relative;
        background-color: $white;
        padding: 20px;
    }
}
.expanded-search:deep() {
    .el-form-item {
        margin-bottom: 0;
    }
}
.expanded-location:deep(),
.expanded-people-count:deep() {
    .activity-filter-location-group {
        display: flex;
    }
    .el-checkbox {
        margin-right: 1em;
    }
    .el-checkbox__label {
        font-size: 12px;
    }
}
.expanded-date:deep() {
    .el-form {
        margin: 0;
    }
    .el-date-editor.el-input,
    .el-input__wrapper {
        box-sizing: border-box;
        width: 100%;
    }
    .filter-button {
        @include smallButtonStyle();
        margin: 0 auto;
    }
    .el-form-item:last-child {
        margin-bottom: 0;
    }
}
.expanded-order-type {
    margin: -20px;
    li {
        line-height: 3em;
        text-align: center;
        border-bottom: 1px solid $grayD;
        &:last-child {
            border-bottom: none;
        }
    }
}
</style>
